import React, { useContext, useState, useEffect } from "react";
import { CartContext } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import "./Header.css";

export default function Header({ navigateTo }) {
  const { cartCount } = useContext(CartContext);
  const { user, isAdmin, isStaff, logout } = useAuth();
  const { i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const hasAdminAccess = isAdmin || isStaff;


  // const activeLang = i18n.language?.startsWith("en") ? "en" : "fa";
  const activeLang = "fa";
  
  useEffect(() => {
  document.documentElement.lang = "fa";
  document.documentElement.dir = "rtl";
  document.body.classList.add("fa-mode");
  document.body.classList.remove("en-mode");

  i18n.changeLanguage("fa");
  localStorage.removeItem("i18nextLng");
}, [i18n]);


  useEffect(() => {
    document.body.classList.toggle("mobile-menu-open", menuOpen);

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [menuOpen]);

  const navigate = (page) => (e) => {
    e.preventDefault();
    navigateTo(page);
    setMenuOpen(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigateTo("shop");
    setMenuOpen(false);
  };

  // const changeLanguage = (lang) => {
  //   i18n.changeLanguage(lang);
  //   document.documentElement.lang = lang === "fa" ? "fa" : "en";
  //   document.documentElement.dir = lang === "fa" ? "rtl" : "ltr";
  // };

  const changeLanguage = (lang) => {
    if (lang === "en") {
      alert("نسخه انگلیسی سایت به‌زودی فعال می‌شود");
      return;
    }

    i18n.changeLanguage("fa");
    document.documentElement.lang = "fa";
    document.documentElement.dir = "rtl";
  };


  const getUserRole = () => {
    if (isAdmin) return { icon: "👑", text: "ادمین" };
    if (isStaff) return { icon: "👔", text: "کارمند" };
    return { icon: "👤", text: "مشتری" };
  };

  const getUserDisplayName = () => {
    return user?.firstName || user?.username || "من";
  };

  const role = getUserRole();

  const menuItems = [
    { label: "صفحه اصلی", mobileLabel: "🏪 فروشگاه", page: "shop" },
    { label: "بلاگ", mobileLabel: "📝 بلاگ", page: "blog-list" },
    { label: "درباره ما", mobileLabel: "ℹ️ درباره ما", page: "about" },
    { label: "تماس با ما", mobileLabel: "📞 تماس با ما", page: "contact" },
  ];

  return (
    <header className="main-header" dir="rtl">
      <div className="header-main-row">
        <a
          href="#"
          onClick={navigate("shop")}
          className="header-logo-link"
          aria-label="صفحه اصلی نقش خیال"
        >
          <img src="/logoNGHs.png" alt="لوگوی نقش خیال" className="header-logo" />
        </a>

        <div className="header-center">
          <a
            href="#"
            onClick={navigate("shop")}
            className="brand-title-link"
            aria-label="نقش خیال"
          >
            {/* <h1 className="brand-name">نقش خیال</h1> */}
          </a>

          <nav className="main-nav" aria-label="منوی اصلی">
            <ul className="nav-links">
              {menuItems.map((item) => (
                <li key={item.label}>
                  <a href="#" onClick={navigate(item.page)}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="header-left">
          <div className="language-switcher" aria-label="انتخاب زبان">
            <button
              type="button"
              className={`lang-btn${activeLang === "fa" ? " active" : ""}`}
              onClick={() => changeLanguage("fa")}
            >
              FA
            </button>

            <button
              type="button"
              className={`lang-btn${activeLang === "en" ? " active" : ""}`}
              onClick={() => changeLanguage("en")}
            >
              EN
            </button>
          </div>

          <a href="#" onClick={navigate("cart")} className="cart-btn" aria-label="سبد خرید">
            <span className="cart-icon">🛒</span>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </a>

          <div className="user-area">
            {user ? (
              <>
                {hasAdminAccess ? (
                  <button
                    type="button"
                    className="admin-panel-btn"
                    onClick={navigate("admin")}
                  >
                    {isAdmin ? "👑 پنل ادمین" : "👔 پنل کارمندی"}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="admin-panel-btn"
                    onClick={navigate("user-panel")}
                  >
                    👤 پنل {getUserDisplayName()}
                  </button>
                )}

                <button type="button" className="logout-btn" onClick={handleLogout}>
                  خروج
                </button>
              </>
            ) : (
              <button type="button" className="login-btn" onClick={navigate("login")}>
                ورود / ثبت‌نام
              </button>
            )}
          </div>

          <button
            type="button"
            className={`hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "بستن منو" : "باز کردن منو"}
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <div className={`mobile-menu${menuOpen ? " active" : ""}`}>
        <nav aria-label="منوی موبایل">
          <ul className="mobile-nav-links">
            {menuItems.map((item) => (
              <li key={item.mobileLabel}>
                <a href="#" onClick={navigate(item.page)}>
                  {item.mobileLabel}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="mobile-language-switcher" aria-label="انتخاب زبان موبایل">
          <button
            type="button"
            className={`lang-btn${activeLang === "fa" ? " active" : ""}`}
            onClick={() => changeLanguage("fa")}
          >
            فارسی
          </button>

          <button
            type="button"
            className={`lang-btn${activeLang === "en" ? " active" : ""}`}
            onClick={() => changeLanguage("en")}
          >
            English
          </button>
        </div>

        <div className="mobile-menu-user">
          {user ? (
            <>
              {hasAdminAccess ? (
                <button
                  type="button"
                  className="mobile-action-btn mobile-admin-btn"
                  onClick={navigate("admin")}
                >
                  {isAdmin ? "👑 پنل ادمین" : "👔 پنل کارمندی"}
                </button>
              ) : (
                <button
                  type="button"
                  className="mobile-action-btn mobile-admin-btn"
                  onClick={navigate("user-panel")}
                >
                  👤 پنل {getUserDisplayName()}
                </button>
              )}

              <button
                type="button"
                className="mobile-action-btn mobile-logout-btn"
                onClick={handleLogout}
              >
                🚪 خروج از حساب
              </button>
            </>
          ) : (
            <button
              type="button"
              className="mobile-action-btn mobile-login-btn"
              onClick={navigate("login")}
            >
              👤 ورود / ثبت‌نام
            </button>
          )}
        </div>
      </div>
    </header>
  );
}